import Vue from 'vue'
import VueRouter from 'vue-router'
import Overview from '../views/Overview.vue'
import Detail from '../views/Detail.vue'
import Compare from '../views/Compare.vue'
import { WPSettings } from '@/WPSettings'

Vue.use(VueRouter)

const routes = [
  {
    path: '/',
    name: 'home',
    component: Overview
  },
  {
    path: '/voertuig/:id/:slug?',
    name: 'detail',
    component: Detail
  },
  {
    path: '/vergelijken',
    name: 'compare',
    component: Compare
  }
]

const router = new VueRouter({
  mode: 'history',
  base: WPSettings.ROUTER_PATH,
  routes
})

export default router
